export const tokens = {
  access: 'pa-at',
  refresh: 'pa-rt',
};

export const setTokens = (response) => {
  const { data: { accessToken, refreshToken } } = response;

  localStorage.setItem(tokens.access, accessToken);
  localStorage.setItem(tokens.refresh, refreshToken);

  return { accessToken, refreshToken };
};

export const getTokens = () => {
  const accessToken = localStorage.getItem(tokens.access);
  const refreshToken = localStorage.getItem(tokens.refresh);

  return { accessToken, refreshToken };
};

export const clearTokens = () => {
  localStorage.removeItem(tokens.access);
  localStorage.removeItem(tokens.refresh);
};

export const saveCurrentLocation = (path) => {
  sessionStorage.setItem('pa-route-precheck', path);
};

export const getCurrentLocation = () => {
  return sessionStorage.getItem('pa-route-precheck');
};

export const clearCurrentLocation = () => {
  sessionStorage.removeItem('pa-route-precheck');
};
